import { z } from "zod";
import { CatalogItemStatus, RewardType } from "../enums";
import {
  currencyCodeSchema,
  dateWindowIssue,
  isDateWindowOrdered,
  moneySchema,
  optionalDateSchema,
  optionalHttpUrlSchema,
} from "./common.schema";

const eligibilitySchema = z.object({
  minTierRank: z.number().int().positive().nullable().optional(),
  allowedSegments: z.array(z.string()),
  allowedMemberTypes: z.array(z.string()),
});

/** Validation schema for creating / editing a catalog item. */
export const rewardCatalogItemSchema = z
  .object({
    programId: z.string().min(1, { message: "program_required" }),
    name: z.string().trim().min(1, { message: "catalog_name_required" }).max(120, {
      message: "max_characters_error",
    }),
    description: z.string().max(1000).optional(),
    rewardType: z.enum(RewardType),
    pointsCost: z.number().int().positive({ message: "points_cost_invalid" }),
    monetaryValue: moneySchema.nullable().optional(),
    currency: currencyCodeSchema.nullable().optional(),
    inventory: z.number().int().nonnegative({ message: "inventory_invalid" }).nullable().optional(),
    perMemberLimit: z
      .number()
      .int()
      .positive({ message: "per_member_limit_invalid" })
      .nullable()
      .optional(),
    startDate: optionalDateSchema,
    endDate: optionalDateSchema,
    imageUrl: optionalHttpUrlSchema,
    status: z.enum(CatalogItemStatus),
    fulfillmentInstructions: z.string().max(1000).nullable().optional(),
    terms: z.string().max(2000).nullable().optional(),
    eligibility: eligibilitySchema,
  })
  .refine(isDateWindowOrdered, dateWindowIssue());

export type RewardCatalogItemFormValues = z.infer<typeof rewardCatalogItemSchema>;
